
import React from "react";

interface CheckItemProps {
  children: React.ReactNode;
}

const CheckItem = ({ children }: CheckItemProps) => {
  return (
    <li className="flex items-start">
      <div className="mr-3 mt-1 bg-green-100 dark:bg-green-900/30 p-1 rounded-full">
        <svg className="h-4 w-4 text-green-600 dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <span>{children}</span>
    </li>
  );
};

export default CheckItem;
